<template>
  <div>
    <b-modal
      :active.sync="displayMapping"
      has-modal-card
      :width="800"
      @close="displayMapping = false"
    >
      <div class="modal-card" style="width: 800px">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{
              $t('compCarbonFormsCommutesHelpFileFormat.title-possible-values')
            }}
          </p>
        </header>
        <section class="modal-card-body">
          <p>
            {{
              $t('compCarbonFormsCommutesHelpFileFormat.text-possible-values')
            }}
          </p>
          <b-table :data="mapping">
            <b-table-column
              field="key"
              :label="$t('compCarbonFormsCommutesHelpFileFormat.header-key')"
              v-slot="props"
            >
              {{ $t('compCarbonFormsCommutesHelpFileFormat.' + props.row.key) }}
            </b-table-column>

            <b-table-column
              field="value"
              :label="$t('compCarbonFormsCommutesHelpFileFormat.header-values')"
              v-slot="props"
            >
              {{ props.row.values }}
            </b-table-column>
          </b-table>
        </section>
      </div>
    </b-modal>
    <b-notification :has-icon="true" icon="file" :closable="false">
      {{ $t('compCarbonFormsCommutesHelpFileFormat.info-1') }}
      <a class="link" href="/api/commutes_template/?ext=tsv" download>{{
        $t('compCarbonFormsCommutesHelpFileFormat.info-2a')
      }}</a>
      {{ $t('compCarbonFormsCommutesHelpFileFormat.info-2b') }}
      <a class="link" href="/api/commutes_template/?ext=csv" download>{{
        $t('compCarbonFormsCommutesHelpFileFormat.info-2c')
      }}</a
      >).
      {{ $t('compCarbonFormsCommutesHelpFileFormat.info-3') }}
      <br /><br />
      <ul style="list-style-type: square; margin-left: 25px">
        <li v-html="$t('compCarbonFormsCommutesHelpFileFormat.file.col1')"></li>
        <li>
          <span
            v-html="$t('compCarbonFormsCommutesHelpFileFormat.file.col2')"
          /><a class="link" @click="displayPositionMapping">
            {{ $t('compCarbonFormsCommutesHelpFileFormat.link-text') }}</a
          >
        </li>
        <li v-html="$t('compCarbonFormsCommutesHelpFileFormat.file.col3')"></li>
        <li v-html="$t('compCarbonFormsCommutesHelpFileFormat.file.col4')"></li>
        <li v-html="$t('compCarbonFormsCommutesHelpFileFormat.file.col5')"></li>
        <li v-html="$t('compCarbonFormsCommutesHelpFileFormat.file.col6')"></li>
        <li v-html="$t('compCarbonFormsCommutesHelpFileFormat.file.col7')"></li>
        <li v-html="$t('compCarbonFormsCommutesHelpFileFormat.file.col8')"></li>
        <li v-html="$t('compCarbonFormsCommutesHelpFileFormat.file.col9')"></li>
        <li
          v-html="$t('compCarbonFormsCommutesHelpFileFormat.file.col10')"
        ></li>
        <li
          v-html="$t('compCarbonFormsCommutesHelpFileFormat.file.col11')"
        ></li>
        <li
          v-html="$t('compCarbonFormsCommutesHelpFileFormat.file.col12')"
        ></li>
        <li
          v-html="$t('compCarbonFormsCommutesHelpFileFormat.file.col13')"
        ></li>
        <li
          v-html="$t('compCarbonFormsCommutesHelpFileFormat.file.col14')"
        ></li>
        <li
          v-html="$t('compCarbonFormsCommutesHelpFileFormat.file.col15')"
        ></li>
        <li
          v-html="$t('compCarbonFormsCommutesHelpFileFormat.file.col16')"
        ></li>
        <li
          v-html="$t('compCarbonFormsCommutesHelpFileFormat.file.col17')"
        ></li>
        <li
          v-html="$t('compCarbonFormsCommutesHelpFileFormat.file.col18')"
        ></li>
        <li
          v-html="$t('compCarbonFormsCommutesHelpFileFormat.file.col19')"
        ></li>
        <li
          v-html="$t('compCarbonFormsCommutesHelpFileFormat.file.col20')"
        ></li>
        <li
          v-html="$t('compCarbonFormsCommutesHelpFileFormat.file.col21')"
        ></li>
      </ul>
    </b-notification>
  </div>
</template>

<script>
import { useCoreStore } from '@/stores/core.js'

import { inverseMapping } from '@/utils/utils'

export default {
  name: 'HelpFileFormat',
  data () {
    return {
      displayMapping: false,
      mapping: [],
      mappingColumns: [
        {
          field: 'key',
          label: this.$t('compCarbonFormsCommutesHelpFileFormat.header-key'),
          centered: true
        },
        {
          field: 'values',
          label: this.$t('compCarbonFormsCommutesHelpFileFormat.header-values'),
          centered: true
        }
      ]
    }
  },
  setup () {
    const coreStore = useCoreStore()
    return { coreStore }
  },
  computed: {
    positions: function () {
      let m = inverseMapping(
        this.coreStore.conf.COMMUTE_POSITION_DICTIONARY.value
      )
      return Object.entries(m).map(([k, v]) => {
        return { key: k + '.short', values: v }
      })
    }
  },
  methods: {
    displayPositionMapping () {
      this.displayMapping = true
      this.mapping = this.positions
    }
  }
}
</script>
